import type { ReactNode } from 'react';
import styles from './buttonGroup.module.css';

interface ButtonGroupProps {
  children: ReactNode;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({
  children,
}: ButtonGroupProps) => {
  return <div className={styles.group}>{children}</div>;
};

export default ButtonGroup;
